import React, { Component } from "react";
import { TransitionGroup } from "react-transition-group";
import { animateScroll } from "react-scroll";
import MessageItem from "./MessageItem";
import MessageInput from "./MessageInput";

import {
  getBotMessageGroup,
  getBetweenTimeoutValue,
  getTimeoutValue,
  getInputTimeoutValue,
  addBotMessageGroup,
  addBotMessages
} from "../Utils/botMessages";
import {
  getUserMessage,
  addUserMessage,
  addUserMessages
} from "../Utils/userMessages";
import { postMessage } from "../Utils/middleware";
import {
  employed_userMessages,
  employed_botMessages,
  self_employed_botMessages,
  self_employed_userMessages
} from "../Constants/messages";

const isJSON = str => {
  if (
    /^[\],:{}\s]*$/.test(
      str
        .replace(/\\["\\\/bfnrtu]/g, "@")
        .replace(
          /"[^"\\\n\r]*"|true|false|null|-?\d+(?:\.\d*)?(?:[eE][+\-]?\d+)?/g,
          "]"
        )
        .replace(/(?:^|:|,)(?:\s*\[)+/g, "")
    )
  ) {
    return true;
  } else {
    return false;
  }
};
class MessageList extends Component {
  state = {
    showInput: false,
    messages: [],
    name: "",
    isIphoneX: true
  };

  constructor(props) {
    super(props);
    this.messages = [
      {
        type: "user",
        message: "Hello"
      }
    ];
  }

  componentDidMount() {
    const { logo } = this.props;
    if (logo === "Bolt") {
      let msggroup = [
        {
          type: "bot",
          message: "Hi, I'm your personal chatbot."
        },
        {
          type: "bot",
          message: `I'm going to test & verify your profile.`
        },
        {
          type: "bot",
          message: "May I take your full name please?"
        }
      ];
      addBotMessageGroup(msggroup);
    } else {
      addBotMessageGroup([
        {
          type: "bot",
          message: "May I take your full name please?"
        }
      ]);
      addBotMessageGroup([
        {
          type: "bot",
          message: "Hi, I'm your personal chatbot."
        },
        {
          type: "bot",
          message: `I'm going to test & verify your profile.`
        },
        {
          type: "bot",
          message: `${logo} have teamed up with Bolt to verify you and then reward you. Are you happy to share your information with them?`
        }
      ]);

      addUserMessage({
        type: "user",
        inputType: "yes/no",
        key: "start"
      });
    }
    this.getBotMessageGroup();
  }

  getBotMessageGroup = () => {
    this.setState({
      showInput: false
    });
    const messageGroup = getBotMessageGroup();

    if (messageGroup) {
      messageGroup.forEach((message, index) => {
        const timeoutValue =
          getTimeoutValue() + (index ? index * getBetweenTimeoutValue() : 0);
        setTimeout(() => {
          this.setMessageInState(message);
          this.scrollToBottom();
          if (index === messageGroup.length - 1) this.toggleUserInput(true);
        }, timeoutValue);
      });
    }
  };

  scrollToBottom(delay = 0) {
    if (delay) {
      setTimeout(() => {
        animateScroll.scrollToBottom({
          duration: 500,
          smooth: "easeInOutQuad"
        });
      }, delay);
    } else {
      animateScroll.scrollToBottom({
        duration: 500,
        smooth: "easeInOutQuad"
      });
    }
  }

  setMessages() {
    const { logo, icon } = this.props;
    const { messages } = this.state;
    console.log("messages", messages);
    return messages.map((message, i) => {
      const firstChild = i !== 0 && messages[i - 1].type !== message.type;
      return (
        <MessageItem
          message={message}
          firstChild={firstChild}
          key={i}
          timeoutValue={getTimeoutValue(message.message)}
          logo={logo}
          icon={icon}
        />
      );
    });
  }

  toggleUserInput(timeout) {
    if (!this.state.showInput) this.scrollToBottom(500);
    const { userMessage } = this.state;
    const showInput = !this.state.showInput;
    if (timeout) {
      setTimeout(() => {
        if (!this.state.showInput) this.scrollToBottom(500);
        this.setState({
          showInput,
          userMessage: showInput ? getUserMessage() : userMessage
        });
      }, getInputTimeoutValue());
    } else {
      this.setState({
        showInput,
        userMessage: showInput ? getUserMessage() : userMessage
      });
    }
  }

  setMessageInState(message) {
    const messages = this.state.messages.slice();
    messages.push(message);
    this.setState({ messages });
  }

  addMessage = message => {
    if (message.finish) postMessage("profileTestfinished", true);
    if (message.inputType === "input" && message.key === "username") {
      setTimeout(() => {
        this.scrollToBottom();
        //break into firstname and lastname;
        let name = message.message.split(" ");
        let firstname = name[0];
        this.setMessageInState({
          type: "bot",
          message: `Great, thanks ${firstname}. `
        });
        this.getBotMessageGroup();
      }, getBetweenTimeoutValue());
    } else if (message.key === "employmentType") {
      console.log("employment", message.message);
      const employ_status = message.message;
      if (employ_status === "Employed") {
        addUserMessages(employed_userMessages);
        addBotMessages(employed_botMessages);
      } else if (employ_status === "Self employed") {
        addUserMessages(self_employed_userMessages);
        addBotMessages(self_employed_botMessages);
      }
      this.getBotMessageGroup();
    } else if (message.key === "wrong_sms") {
      addUserMessage({
        type: "user",
        inputType: "input",
        placeholder: "6-digits",
        key: "sms"
      });
      addUserMessage({
        type: "user",
        inputType: "input",
        placeholder: "",
        key: "phone"
      });
      addBotMessageGroup([
        {
          type: "bot",
          message: "Please confirm the sms code received."
        }
      ]);
      addBotMessageGroup([
        {
          type: "bot",
          message: `SMS Code is not matching. Try again.`
        }
      ]);
      this.getBotMessageGroup();
    } else if (message.key === "no_received") {
      addUserMessage({
        type: "user",
        inputType: "input",
        placeholder: "6-digits",
        key: "sms"
      });
      addUserMessage({
        type: "user",
        inputType: "input",
        placeholder: "",
        key: "phone"
      });
      addBotMessageGroup([
        {
          type: "bot",
          message: "Please confirm the sms code received."
        }
      ]);
      addBotMessageGroup([
        {
          type: "bot",
          message: `Try again.`
        }
      ]);
      this.getBotMessageGroup();
    } else if (message.key === "current_address_startdate") {
      console.log("start date");
      console.log("message", message);
      if (message.status === "Rented") {
        addBotMessageGroup([
          {
            type: "bot",
            message:
              "I will need to check how you have behaved in your current property, so I need your landlord or agent's name please?"
          }
        ]);
        addUserMessage({
          type: "user",
          inputType: "input",
          key: "LA_phone",
          placeholder: ""
        });
        addUserMessage({
          type: "user",
          inputType: "input",
          key: "LA_email",
          placeholder: ""
        });
        addUserMessage({
          type: "user",
          inputType: "input",
          key: "LA_username",
          placeholder: "First Name Last Name"
        });
      }
      this.getBotMessageGroup();
    } else if (
      message.key === "LA_username" ||
      message.key === "partner_username"
    ) {
      let name = message.message.split(" ");
      let firstname = name[0];
      addBotMessageGroup([
        {
          type: "bot",
          message: `May I also have a phone number for ${firstname} to help me speed things up?`
        }
      ]);
      addBotMessageGroup([
        {
          type: "bot",
          message: `May I have an email for ${firstname} please?`
        }
      ]);
      this.getBotMessageGroup();
    } else {
      if (typeof message.allowNotification !== "undefined") {
        if (this.stoppedMessage) {
          postMessage("allowNotificationsTwice", message.allowNotification);
        } else {
          postMessage("allowNotifications", message.allowNotification);
        }
      }
      if (typeof message.moveBot !== "undefined" && message.moveBot) {
        if (message.allowNotification === true) {
          if (message.twiceAsked) {
            for (let i = 0; i < message.moveBot; i++) {
              getBotMessageGroup();
            }
          } else {
            this.stoppedMessage = message;
            return;
          }
        } else {
          for (let i = 0; i < message.moveBot; i++) {
            getBotMessageGroup();
          }
        }
      }
      if (
        typeof message.moveUser !== "undefined" &&
        message.moveUser &&
        message.allowNotification !== true
      ) {
        for (let i = 0; i < message.moveUser; i++) {
          getUserMessage();
        }
      }
      if (!message.finish) {
        setTimeout(() => {
          this.getBotMessageGroup();
        }, 1000);
      }
    }

    this.setMessageInState(message);
    this.toggleUserInput();
  };

  render() {
    const { logo } = this.props;
    const { showInput, userMessage, isIphoneX } = this.state;
    return (
      <div className="message-list-wrapper">
        {this.setMessages()}
        <TransitionGroup component="div" className="message-input-container">
          {showInput ? (
            <MessageInput
              message={userMessage}
              addMessage={this.addMessage}
              isIphoneX={isIphoneX}
              logo={logo}
            />
          ) : null}
        </TransitionGroup>
      </div>
    );
  }
}

export default MessageList;



// WEBPACK FOOTER //
// ./src/Components/MessageList.js